import { useEffect, useState } from "react";
import { useMyProviderDataClient } from "../../../../context/ApiContext";

export const useShoutouts = (
  username?: string,
  year?: string,
  quarter?: number,
  enabled: boolean = true
) => {
  const client = useMyProviderDataClient();

  const [data, setData] = useState<string[][]>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled || !username || !year) return;

    const load = async () => {
      try {
        setLoading(true);

        const res = await client.get(
          "/EmployeeInformation/Shoutouts",
          { params: { username, year, quarter } }
        );

        const shoutouts = res.data;

        if (!Array.isArray(shoutouts) || shoutouts.length === 0) {
          setData(undefined);
          return;
        }

        const formatted = shoutouts.map((row: any) => {
          const created = new Date(row.created);
          const createdString = `${created.getMonth() + 1}/${created.getDate()}`;

          return [
            createdString,
            row.text,
            row.category,
          ];
        });

        setData(formatted);
      } catch (err) {
        console.error(err);
        setData(undefined);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [username, year, quarter, enabled, client]);

  return { data, loading };
};